import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { toast } from "sonner";


export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            gcTime: 1000 * 60 * 60 * 24, // 24 hours
            staleTime: 1000 * 60 * 5,
        },
    },
    mutationCache: new MutationCache({
        onError: (error) => {

            // if (error.message === "NO TOKEN") {
            //     throw redirect({
            //         to: "/login"
            //     })
            // }

        }
    }),
    queryCache: new QueryCache({
        onError: (error) => {

            console.log("onError: ", JSON.stringify(error), error?.shape?.data?.httpStatus)

            if (error.message === "NO TOKEN") {
                throw redirect({
                    to: "/login"
                })
            }

            if (error?.shape?.data?.httpStatus === 401) {
                throw redirect({
                    to: "/not-authorized"
                })
            }

            if (error?.shape?.data?.httpStatus === 403) {
                toast.error("You don't have permission to access this resource", {
                    id: "403"
                })
                throw redirect({
                    to: "/login"
                })
            }

        }
    })
});